import React from "react";
import Items from "./components/items";
import { withRouter } from "react-router-dom";
function Itemstable() {
  return <Items></Items>;
}
export default withRouter(Itemstable);
